import { API_BASE_URL } from "config";
import { StatusCodes } from "http-status-codes";

import { BaseService } from "./base-service";

export interface FAQ {
  id: string;
  question: string;
  answer: string | null;
}

export interface FAQFacts {
  region?: string;
  [key: string]: string | undefined;
}

export class HardwareSupportFaq extends BaseService {
  constructor() {
    super(API_BASE_URL);
  }

  private constructQueryString(facts: FAQFacts): string {
    const params = new URLSearchParams();

    Object.entries(facts).forEach(([key, value]) => {
      if (value) {
        params.append(key, value);
      }
    });

    return params.toString();
  }

  public async getHardwareSupportFaq(facts?: FAQFacts): Promise<FAQ[]> {
    let endpoint = "/hardware-support-faq";

    if (facts && Object.keys(facts).length > 0) {
      const queryString = this.constructQueryString(facts);
      endpoint += `?${queryString}`;
    }

    const response = await this.fetch(endpoint);
    if (response.status !== StatusCodes.OK) {
      throw new Error("An error occurred while fetching hardware support faq.");
    }
    const jsonResponse = await response.json();

    return jsonResponse;
  }
}
